import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormGroup, Button } from 'react-bootstrap';
import { Redirect, Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';

import { signIn, setSignedOutExplicitly } from '../actions/auth-user';

import Loader from '../components/common/loader';
import EmailInput from '../components/common/email-input';
import PasswordInput from '../components/common/password-input';

import { getRedirectAfterSignInPath } from '../tools';
import { validateSignInRequest } from '../tools/validation/auth/sign-in-request-validation';
import validation from '../tools/validation';

import unauthorizedSubcodes from '../constants/unauthorized-subcodes';

class SignIn extends Component {
  constructor(props) {
    super(props);

    this.handleSignin = this.handleSignin.bind(this);
  }

  handleSignin(data) {
    this.props.signIn(data.email, data.password);
  }

  renderUserActivationSuggestion() {
    const { authUser, userSignIn } = this.props;

    const error = authUser.get('error');

    if (error.subcode !== unauthorizedSubcodes.UserAccountIsNotActivated) {
      return null;
    }

    let userActivationLink = `user-activation/?userEmail=${userSignIn.get(
      'signInEmail'
    )}`;

    return (
      <p>
        You need to verify your email. Please request verification link{' '}
        <Link to={userActivationLink}>here</Link>.
      </p>
    );
  }

  renderErrorMessage() {
    const { authUser } = this.props;

    const error = authUser.get('error');

    if (!error) {
      return null;
    }

    return (
      <div className="alert alert-danger" role="alert">
        {error.text} {this.renderUserActivationSuggestion()}
      </div>
    );
  }

  componentWillUnmount() {
    this.props.setSignedOutExplicitly(false);
  }

  render() {
    const { authUser, location, handleSubmit } = this.props;

    if (authUser.get('userId')) {
      const userTypeDefaultPathname = getRedirectAfterSignInPath(
        authUser.get('userType')
      );

      const previousPageRedirectPath =
        !authUser.get('signedOutExplicitly') &&
        location.state &&
        location.state.from;

      const redirectPath = previousPageRedirectPath || {
        pathname: userTypeDefaultPathname
      };

      return <Redirect to={redirectPath} />;
    }

    return (
      <div className="main-section">
        <div className="segment">
          <form
            className="form-signin"
            onSubmit={handleSubmit(this.handleSignin)}
          >
            <div className="text-center">
              <h3>Please sign in</h3>
            </div>

            {this.renderErrorMessage()}

            <Field name="email" component={EmailInput} />

            <Field name="password" component={PasswordInput} />

            <FormGroup>
              <Link to="/forgot-password">Forgot password?</Link>
            </FormGroup>

            <Button type="submit" bsStyle="primary" block>
              <i className="i-apli-log-in" /> Log In
            </Button>
          </form>

          <Loader visible={authUser.get('isLoading')} />
        </div>
      </div>
    );
  }
}

SignIn = reduxForm({
  form: 'loginForm',
  validate: validation(validateSignInRequest)
})(SignIn);

SignIn = connect(
  state => ({ authUser: state.authUser, userSignIn: state.userSignIn }),
  { signIn, setSignedOutExplicitly }
)(SignIn);

export default SignIn;



// WEBPACK FOOTER //
// ./src/containers/sign-in.js